var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof _global == "object" && _global && _global.Object === Object && _global;
exports = freeGlobal;
export default exports;